const DEFAULT_DEBOUNCE_MS = 500;

export function scheduleDebounced(
  timeoutRef: { current: ReturnType<typeof setTimeout> | undefined },
  task: () => void,
  delayMs = DEFAULT_DEBOUNCE_MS,
): void {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
  }
  timeoutRef.current = setTimeout(task, delayMs);
}

export function clearScheduledDebounced(timeoutRef: {
  current: ReturnType<typeof setTimeout> | undefined;
}): void {
  if (timeoutRef.current) {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = undefined;
  }
}
